<template>
  <div>
    
    
    <baidu-map
        ref="bMap"
      class="map"
       @ready="handler"
      :center="mapData.center"
      :zoom="mapData.zoom"
      :inertial-dragging="false"
    >
        
      <bm-marker
        :position="{ lng: lng, lat: lat+0.002 }"
         @click="infoWindowOpen"
        :dragging="true"
        animation="BMAP_ANIMATION_BOUNCE"
      >
        <!-- <bm-label
          content=""
          :labelStyle="{ color: 'red', fontSize: '24px' }"
          :offset="{ width: -35, height: 30 }"
        /> -->
        <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen"></bm-info-window>
      </bm-marker>
      <bm-marker
        :position="{ lng: lng+0.004, lat: lat+0.001 }"
        :dragging="true"
        animation="BMAP_ANIMATION_BOUNCE"
      >
        <bm-label
          content=""
          :labelStyle="{ color: '#18bd85', fontSize: '24px' }"
        />
      </bm-marker>
      <bm-circle
       fillColor="blue"
        :center="circlePath.center"
        :fillOpacity="0.1"
        :radius="circlePath.radius"
        stroke-color="blue"
        :stroke-opacity="0"
        :stroke-weight="1"
        @lineupdate="updateCirclePath"
        :editing="true"
      ></bm-circle>
    </baidu-map>
    <div class="back-box">
         <el-button size="mini" round @click="mapBack">
            <img class="map_icon" @click="mapBack" src="@/assets/images/back.png" alt=""/>
         </el-button>
    </div>
    <div class="map-center-title">
        {{name}}火灾高风险区域整治
    </div>
    <div class="map_box map_left map_padding">
        <div class="map_box_top">
            <div class="flex items-center justify-center">
            <img src="@/assets/images/top_bg.png" alt="">
            <!-- <div class="map_primary">基本情况</div> -->
            </div>
         <el-row>
            <el-col :span="8" v-for="(item,index) in place_type_count" :key="index">
                <div class="flex">
                    <img class="map_icon" src="@/assets/images/home.png" alt="">
                    <div>
                        <div>{{item.name}}</div>
                        <div>{{item.count}}</div>
                    </div>
                </div>
            </el-col>
           
            
        </el-row>
        </div>
        <div class="map_primary map_padding">社区完成排查场所（累计）</div>
        <div class="map_padding map_bottom">
            <div class="map_bgimg ltop">
                <img src="@/assets/images/map_bg_ltop.png" alt="">
            </div>
            <div class="map_bgimg rtop">
                <img src="@/assets/images/map_bg_rtop.png" alt="">
            </div>
            
            <div class="map_single" v-for="(item,index) in left_data" :key="index">
                <div class="flex justify-between">
                    <span>{{item.name}}</span>
                    <span>{{item.count}}</span>
                </div>
                <el-progress :percentage="80" :color="customColor" :show-text="false"></el-progress>
            </div>
            
         
            <div class="map_bgimg lbottom">
                <img src="@/assets/images/map_bg_lbottom.png" alt="">
            </div>
            <div class="map_bgimg rbottom">
                <img src="@/assets/images/map_bg_rbottom.png" alt="">
            </div>
        </div>
    </div>
    <div class="map_box map_right map_padding">
        <div class="map_box_top flex justify-center items-center">
            <div class="position">
                <div class="count flex justify-center items-center">
                    {{right_new_count}}家
                </div>
                <div class="flex justify-center items-center">
                    今日排查
                </div>
            </div>
            <img src="@/assets/images/bg1.png" alt="" width="140px" height="140px">
            <!-- <el-progress :show-text="false" type="circle" :percentage="100"></el-progress> -->
        </div>
        <div class="map_primary map_padding">社区完成排查场所（今日）</div>
        <div class="map_padding map_bottom">
            
            <div class="map_bgimg ltop">
                <img src="@/assets/images/map_bg_ltop.png" alt="">
            </div>
            <div class="map_bgimg rtop">
                <img src="@/assets/images/map_bg_rtop.png" alt="">
            </div>
            <el-scrollbar class="map_bottom_scroll">
            <div class="map_single" v-for="(item,index) in right_new_data" :key="index">
                <div class="flex justify-between">
                    <span>{{item.name}}</span>
                    <span>{{item.count}}</span>
                </div>
                <el-progress :percentage="80" :color="customColor" :show-text="false"></el-progress>
            </div>
            
            
            </el-scrollbar>
            <div class="map_bgimg lbottom">
                <img src="@/assets/images/map_bg_lbottom.png" alt="">
            </div>
            <div class="map_bgimg rbottom">
                <img src="@/assets/images/map_bg_rbottom.png" alt="">
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mapData: {
        //中心坐标
        center: {lng:116.404,lat:39.915},
        //缩放级别
        zoom: 15,
      },
      circlePath: {
        center: {
          lng: 116.404,
          lat: 39.915,
        },
        radius: 800,
      },
      show: false,
      customColor: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 40},
          {color: '#5cb87a', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#6f7ad3', percentage: 100}
        ],
        street_id:26,//街道id
        place_type_count:[],//获取基本情况 场所类型总统计场所数量
        left_data:[],//社区完成排查场所数量
        right_new_data:[],//右边场所类型新增排查场所数量
        right_new_count:0,//右边 获取今天场所 排查总新增数量
        place_new_count:0,//获取今天场所 添加数量 （待定）
        lng:116.404,
        lat:39.915,
        map:null,
        maphtml:"",

    };
  },
  sockets:{
    connect(){
        this.webSocketSend();
    },
    disconnect:()=>console.log("断开连接"),
    error:()=>  console.log("连接异常"),
    loginSuccess:  console.log,
    placeData(data){
        const da = JSON.parse(data)[0]
        // console.log(JSON.parse(data))
        this.name=da.name
        this.place_type_count=da.place_type_count
        this.left_data=da.left_data

        this.right_new_data=da.right_new_data
        this.right_new_count=da.right_new_count
        this.place_new_count=da.place_new_count

        this.$_invoke2("received",{
            message_id:JSON.parse(data)["message_id"],
            message_token:JSON.parse(data)["message_token"],
        }).then(()=>{
              console.log("成功")
        });

    },
    loginFail:  console.log,
    Heart: console.log
  },
  mounted(){
    this.webSocketInit()
    
  },
  methods: {
    webSocketInit(){
        this.$socket.open();
    },
    webSocketSend(){
        // console.log(this.street_id.toString())
        // 尝试连接 随便发送一个
        this.$socket.emit('event', 'hello, hyperf', console.log);
        // 推当前的街道id 连接进行推送消息
        this.$socket.emit('login', `{"street_id":"${this.street_id}"}`);
        //定时器  心跳
        setInterval(()=>{
            this.$socket.emit('heart',`{"street_id":"${this.street_id}"}`);
        }, 10000);
    },

    infoWindowClose () {
      this.show = false
    },
    infoWindowOpen () {
      this.show = true
    },
    updateCirclePath(e) {
      this.circlePath.center = e.target.getCenter();
      this.circlePath.radius = e.target.getRadius();
    },
    mapBack(){
        this.$router.go(-1);
    },
    handler({ BMap }){
        const myGeo= new BMap.Geocoder();
        myGeo.getPoint(this.name,(point)=>{
            
            // console.log("经纬度"+JSON.stringify(point))
            this.lng=point.lng;
            this.lat=point.lat;
            this.mapData.center={lng:point.lng,lat:point.lat};
            this.circlePath.center.lng=point.lng;
            this.circlePath.center.lat=point.lat;
            // this.$refs.bMap.reload();
            // marker.setAnimation(BMAP_ANIMATION_BOUNCE);
        })
    }
  },
};
</script>
<style lang="scss">
.map {
  width: 100%;
  height: 100vh;
  
}
.map_padding{
    padding:10px;
}
.map_primary{
    color:#18bd85;
    font-size:16px;
}
.map_icon{
    width:25px;
    height:25px;
    margin-right: 3px;
    margin-top: 3px;
}
.map_box{
    position: absolute;
   
    top:50%;
    transform: translateY(-50%);
    width:400px;
    height:auto;
    background:#000;
    opacity: 0.6;
    &.map_left{
        left:0px;
    }
    &.map_right{
        right:0px;
    }
    color:#fff;
}
.map_box_top{
    min-height:170px;
    // color:#18bd85;
    position: relative;
    .position{
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
        .count{
            font-size:20px;
        }
    }
}
.justify-center{
    justify-content: center;
}
.map_single{
    margin:12px 0;
}

.map_bottom{
    position: relative;
    border:1px solid #18bd85;
    box-shadow:2px 2px 12px #06C;
    border-radius: 15px;
    
    
    // .map_bottom_scroll{
    //     max-height:100px;
    // }
    .map_bgimg{
        position: absolute;
        // width:0px;
        // height:100px;
        &.ltop{
            top:-2px;
            left:-2px;
        }
        &.rtop{
            top:-2px;
            right:-2px;
        }
        &.lbottom{
            bottom:-6px;
            left:-2px;
        }
        &.rbottom{
            bottom:-6px;
            right:-2px;
        }
    }
}
.el-col{
    margin-top: 5px;
    margin-bottom: 10px;
    padding:0 5px;
}

.map-center-title{
    position: absolute;
    left:50%;
    top:0;
    transform: translateX(-50%);
    font-size:35px;
    font-weight: bold;
}

.el-scrollbar .el-scrollbar__wrap{
        overflow-x:hidden;
        padding-bottom: 13px;
    }
    .el-scrollbar__bar.is-horizontal{
        display: none;
    }

.back-box{
    position: absolute;
    top:5px;
    left:5px;
}


</style>